import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import PackageId from 'checkout/components/PackageId';
import PriceInfo from 'checkout/components/PriceSummary/PriceInfo';
import PriceInfoMobile from 'checkout/components/PriceSummary/PriceInfoMobile';
import Summary from 'checkout/components/PriceSummary/Summary';
import { getShowPriceChanged } from 'checkout/store/selectors/actualization';
import { getHotelLinkWithRequestId } from 'checkout/store/selectors/hotel';
import {
  getIsOrderPrebuildFetching,
  getPriceInfo,
  getRemainingPaymentAmount,
} from 'checkout/store/selectors/order';
import { getInstantConfirm } from 'checkout/store/selectors/package';
import Preloader from 'src/components/Preloader';
import { getIsMobile } from 'src/store/view/selectors';
import SidebarPrice from './SidebarPrice';

const baseCls = 'checkout-sidebar-summary';

const SidebarSummary = ({
  priceInfo,
  fullPrice,
  showPriceChanged,
  instantConfirm,
  hotelLink,
  isFetching,
  isMobile,
}) => (
  <div className={baseCls}>
    <SidebarPrice
      className={`${baseCls}__checker`}
      showPriceChanged={showPriceChanged}
      hotelLink={hotelLink}
      isMobile={isMobile}
    >
      {isFetching ? (
        <Preloader throbber className={`${baseCls}--throbber`} />
      ) : (
        <Summary value={fullPrice} instantConfirm={instantConfirm}>
          {isMobile && <PackageId />}
        </Summary>
      )}
    </SidebarPrice>
    <div className={`${baseCls}__extras`}>
      {isMobile ? (
        <PriceInfoMobile data={priceInfo} />
      ) : (
        <PriceInfo data={priceInfo} />
      )}
    </div>
  </div>
);

SidebarSummary.defaultProps = {
  fullPrice: null,
};

SidebarSummary.propTypes = {
  priceInfo: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.array,
  ]).isRequired,
  fullPrice: PropTypes.number,
  showPriceChanged: PropTypes.bool.isRequired,
  instantConfirm: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  fullPrice: getRemainingPaymentAmount(state),
  priceInfo: getPriceInfo(state),
  showPriceChanged: getShowPriceChanged(state),
  hotelLink: getHotelLinkWithRequestId(state),
  instantConfirm: getInstantConfirm(state),
  isFetching: getIsOrderPrebuildFetching(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(SidebarSummary);
